/** Base path do portal do representante (prefixo da rota React). */
export const PARTNER_CONSOLE_BASE = "/partner/console";

export const PARTNER_CONSOLE_SEGMENT = {
  overview: "overview",
  live: "live",
  dashboard: "dashboard",
  workspaces: "workspaces",
  presence: "presence",
  pricing: "pricing",
  workspaceCreate: "workspaces/new",
  team: "team",
  passagens: "passagens",
};

export const PARTNER_CONSOLE_PATH = {
  overview: `${PARTNER_CONSOLE_BASE}/${PARTNER_CONSOLE_SEGMENT.overview}`,
  live: `${PARTNER_CONSOLE_BASE}/${PARTNER_CONSOLE_SEGMENT.live}`,
  dashboard: `${PARTNER_CONSOLE_BASE}/${PARTNER_CONSOLE_SEGMENT.dashboard}`,
  workspaces: `${PARTNER_CONSOLE_BASE}/${PARTNER_CONSOLE_SEGMENT.workspaces}`,
  presence: `${PARTNER_CONSOLE_BASE}/${PARTNER_CONSOLE_SEGMENT.presence}`,
  pricing: `${PARTNER_CONSOLE_BASE}/${PARTNER_CONSOLE_SEGMENT.pricing}`,
  workspaceCreate: `${PARTNER_CONSOLE_BASE}/${PARTNER_CONSOLE_SEGMENT.workspaceCreate}`,
  team: `${PARTNER_CONSOLE_BASE}/${PARTNER_CONSOLE_SEGMENT.team}`,
  passagens: `${PARTNER_CONSOLE_BASE}/${PARTNER_CONSOLE_SEGMENT.passagens}`,
};

/** Path absoluto de uma aba do dashboard consolidado do representante. */
export function partnerDashboardTabPath(tabKey) {
  const key = String(tabKey || "live").trim() || "live";
  return `${PARTNER_CONSOLE_PATH.dashboard}/${encodeURIComponent(key)}`;
}

/** Path absoluto do detalhe de um workspace do representante. */
export function partnerWorkspaceDetailPath(dominioId) {
  const id = String(dominioId || "").trim();
  if (!id) return PARTNER_CONSOLE_PATH.workspaces;
  return `${PARTNER_CONSOLE_BASE}/${PARTNER_CONSOLE_SEGMENT.workspaces}/${encodeURIComponent(id)}`;
}
